import { useEffect, useRef } from 'react'

export const useDidMount = (cb: () => (() => void) | void) => {
  const isMounted = useRef(false)

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      return cb()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
